"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevels = exports.LOG_LEVEL_STYLE = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Info"] = 3] = "Info";
    LogLevel[LogLevel["Error"] = 4] = "Error";
    LogLevel[LogLevel["Fatal"] = 5] = "Fatal";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
exports.LOG_LEVEL_STYLE = {
    0: { color: "#4a4a4a", bg: "#e0e0e0" },
    1: { color: "#007acc", bg: "#f0f0f0" },
    2: { color: "#856404", bg: "#fff3cd" },
    3: { color: "#0c5460", bg: "#d1ecf1" },
    4: { color: "#721c24", bg: "#f8d7da" },
    5: { color: "#721c24", bg: "#f5c6cb" }
};
class LogLevels {
    static FromString(val) {
        if (val == null) {
            throw new Error("LogLevel string must be set.");
        }
        switch (val.toUpperCase()) {
            case "TRACE":
                return LogLevel.Trace;
            case "DEBUG":
                return LogLevel.Debug;
            case "INFO":
                return LogLevel.Info;
            case "WARN":
                return LogLevel.Warn;
            case "ERROR":
                return LogLevel.Error;
            case "FATAL":
                return LogLevel.Fatal;
            default:
                throw new Error("Unsupported Log Level");
        }
    }
}
exports.LogLevels = LogLevels;
